<template>
  <b-card-actions action-collapse title="Filtros" ref="filterCard" class="custom-filter">
    <b-row>
      <!-- <b-col md="2">
        <b-button
          size="sm"
          variant="outline-primary"
          :to="{ name: 'admin-image-library-register' }"
        >
          Adicionar
        </b-button>
      </b-col> -->
      <b-col :md="getColLenght(field)" v-for="(field, index) in fields" :key="index">
        <div class="form-label-group">
          <template v-if="field.type == 'text'">
            <b-form-group :label="field.placeholder" :label-for="field.id">
              <b-form-input
                :id="field.id"
                :type="field.inputType"
                v-model="filterForm[field.model]"
              />
              <!-- <label :for="field.id">{{ field.placeholder }}</label> -->
            </b-form-group>
          </template>

          <template v-if="field.type == 'list'">
            <b-form-group :label="field.placeholder" :label-for="field.id">
              <v-select
                :id="field.id"
                v-model="filterForm[field.model]"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="field.array"
              >
                <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
              </v-select>
            </b-form-group>
          </template>

          <template v-if="field.type == 'date'">
            <b-form-group :label="field.placeholder" :label-for="field.id">
              <!-- <h5>{{field.placeholder}}</h5> -->
              <flat-pickr
                v-model="filterForm[field.model]"
                class="form-control"
                :config="{ enableTime: false, dateFormat: 'd-m-Y' }"
              />
              <!-- :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }" -->
            </b-form-group>
          </template>
          <!-- <template v-if="field.type == 'list'">
            <b-form-input
              :list="field.list"
              :placeholder="field.placeholder"
              :id="field.id"

              v-model="filterForm[field.model]"
            />
            <label :for="field.list">Origem</label>
            <datalist :id="field.list">
              <option v-for="(data, index) in field.array" :key="index">
                {{ data.name }}
              </option>
            </datalist>
          </template> -->
        </div>
      </b-col>
      <b-col md="4" class="filter-buttons">
        <b-button variant="outline-success" @click="onFilter">
          Aplicar
        </b-button>
        <b-button
          variant="outline-danger"
          v-if="displayClearFilterButton"
          @click="onClear"
        >
          Limpar
        </b-button>
      </b-col>
    </b-row>
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import { BButton, BRow, BCol, BFormInput, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  props: {
    fields: {
      required: true,
      type: Array,
    },
    startCollapsed: {
      type: Boolean,
      default: true,
    },
    totalRows: {
      type: Number,
      default: 0,
    },
    selectedFilter: {
      type: Object,
    },
  },
  created() {
    // console.log("custom filter selected filter: ", this.selectedFilter);
    if (this.selectedFilter) {
      if (Object.keys(this.selectedFilter).length > 0) {
        Object.keys(this.selectedFilter).forEach((item) => {
          this.filterForm[item] = this.selectedFilter[item];
        });
      }
    }
  },
  data() {
    return {
      filterForm: {},
    };
  },
  computed: {
    displayClearFilterButton() {
      let canDisplay = false;
      Object.keys(this.filterForm).forEach((item) => {
        if (this.filterForm[item]) {
          canDisplay = true;
        }
      });
      return canDisplay;
    },
    titleFilter() {
      return `Filtro | ${this.totalRows} Registros`;
    },
  },
  methods: {
    getColLenght(field) {
      if (field.type == 'list') {
        return '4';
      }
      return '3';
    },
    onFilter() {
      this.$emit("onFilter", this.filterForm);
    },
    onClear() {
      Object.keys(this.filterForm).forEach((item) => {
        this.filterForm[item] = "";
      });
      this.$emit("onClear");
    },
  },
  components: {
    BCardActions,
    BButton,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BFormGroup,
    flatPickr,
  },
};
</script>

<style>
</style>
